import { render } from "./patient-info.vue?vue&type=template&id=6e966706&scoped=true"
import script from "./patient-info.vue?vue&type=script&lang=js"
export * from "./patient-info.vue?vue&type=script&lang=js"

import "./patient-info.vue?vue&type=style&index=0&id=6e966706&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e966706"]])

export default __exports__